import React from "react";
import PropTypes from "prop-types";
import ControlSessionModal from "@monitor/pages/Monitor/ControlSession/ControlSessionModal3";
import ResetSessionModal from "../../ResetSessionModal/ResetSessionModal";
import EditFermentationModal from "../../EditFermentationModal/EditFermentationModal";
import BrewModal from "@common/components/BrewModal/BrewModal";
import WifiModal from "../../WifiModal/WifiModal";
import AddDeviceModal from "../../AddDeviceModal/AddDeviceModal";
import UnregisterDeviceModal from "../../UnregisterDeviceModal/UnregisterDeviceModal";
import EditDeviceModal from "../../EditDeviceModal/EditDeviceModal";
import CleaningModal from "../../CleaningModal/CleaningModal";
import SupportAcidModal from "../../SupportAcidModal/SupportAcidModal";
import { useBreweryModalContext } from "../../hooks/useBreweryModalContext";

export const BreweryModals = ({ userInfo, fetchBrewery }) => {
  const { modals, actions } = useBreweryModalContext();

  const handleEditFermentationClose = () => {
    actions.closeEditFermentationModal();
    if (fetchBrewery) {
      fetchBrewery();
    }
  };

  return (
    <>
      <ControlSessionModal
        show={modals.stopSession.isOpen}
        sessionID={modals.stopSession.selectedSession}
        handleClose={actions.closeStopSessionModal}
      />
      <ResetSessionModal
        show={modals.resetSession.isOpen}
        sessionID={modals.resetSession.selectedSession}
        handleClose={actions.closeResetSessionModal}
      />
      {modals.editFermentation.isOpen && (
        <EditFermentationModal
          show={modals.editFermentation.isOpen}
          device={modals.editFermentation.fermentationDevice}
          brewerId={userInfo?.user?.id}
          handleClose={handleEditFermentationClose}
        />
      )}
      <BrewModal
        show={modals.brew.isOpen}
        handleClose={actions.closeBrewModal}
        selectedDevice={modals.brew.selectedDevice}
        selectedRecipe={modals.brew.selectedRecipe}
        fetchBrewery={fetchBrewery}
      />
      <WifiModal
        show={modals.wifi.isOpen}
        handleClose={actions.closeWifiModal}
      />
      <AddDeviceModal
        user={userInfo?.user}
        show={modals.addDevice.isOpen}
        handleClose={actions.closeAddDeviceModal}
        fetchBrewery={fetchBrewery}
      />
      <UnregisterDeviceModal
        show={modals.unregister.isOpen}
        handleClose={actions.closeUnregisterDeviceModal}
        unregisterDeviceUUID={modals.unregister.deviceUUID}
      />
      <EditDeviceModal
        show={modals.device.isOpen}
        handleClose={actions.closeDeviceModal}
        serialNumber={modals.device.selectedSerialNumber}
      />
      <CleaningModal
        show={modals.cleaning.isOpen}
        type={modals.cleaning.cleaningType}
        handleClose={actions.toggleCleaningModal}
        deviceUUID={modals.cleaning.deviceUUID}
      />
      <SupportAcidModal
        show={modals.acidSupport.isOpen}
        handleClose={actions.closeAcidSupportModal}
      />
    </>
  );
};

BreweryModals.propTypes = {
  userInfo: PropTypes.object,
  fetchBrewery: PropTypes.func,
};

BreweryModals.defaultProps = {
  userInfo: null,
  fetchBrewery: () => {},
};

export default BreweryModals;
